import { Box, Flex, FlexProps, Text } from "@chakra-ui/react";
import Link from "next/link";
import React, { ReactNode } from "react";

interface Props {
  text: string;
  textSize?: string | number;
  iconStyle?: object;
  link: string;
  handleToggle?: () => void;
  show: boolean;
  icon?: ReactNode;
  isActive?: boolean;
  pl?: number;
}

function NavCollapseButton({ text, textSize, handleToggle, link = "#", show, icon, iconStyle, isActive, ...props }: Props & FlexProps) {
  return (
    <Flex
      align="center"
      userSelect="none"
      color={isActive ? "blue.500" : "gray.500"}
      cursor="pointer"
      borderRightColor={isActive ? "blue.500" : "transparent"}
      borderRightWidth="2px"
      py={3}
      {...props}>
      <Link passHref href={link}>
        <Flex as="a" _hover={{ color: "blue.500" }} transition="all .3s ease">
          {icon && (
            <Box my="auto" fontSize="xl" mr={2}>
              {icon}
            </Box>
          )}
          <Text my="auto" fontSize={textSize} fontWeight={700} isTruncated>
            {text}
          </Text>
        </Flex>
      </Link>
      {/* <Button my="auto" variant="ghost" mr={6} borderRadius="30px" p={0} minH="none" fontSize="2xl" onClick={handleToggle} {...iconStyle}>
        {!show ? <HiChevronDown /> : <HiChevronUp />}
      </Button> */}
    </Flex>
  );
}

export default NavCollapseButton;
